import React, { useEffect, useState } from 'react';
import { Pantallas } from '../services/api';
import { Modal, LabeledInput, LabeledSelect } from './ui';

export default function GroupMessagesEditor({ group, onSaved }) {
  const [rows, setRows] = useState(group?.mensajes || []);
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState({ mensaje: '', status: 'activo', fecha_inicio: '', fecha_fin: '' });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setRows(group?.mensajes || []);
  }, [group?._id, group?.mensajes]);

  const remove = (id) => setRows(rs => rs.filter(r => r.id !== id));
  const toggle = (id) => setRows(rs => rs.map(r => r.id === id ? { ...r, status: r.status === 'activo' ? 'inactivo' : 'activo' } : r));

  const add = () => {
    if (!draft.mensaje.trim()) { alert('Ingresa un mensaje'); return; }
    const id = crypto?.randomUUID?.() || Math.random().toString(36).slice(2);
    setRows(rs => [...rs, {
      id,
      mensaje: draft.mensaje.trim(),
      status: draft.status || 'activo',
      fecha_inicio: draft.fecha_inicio ? new Date(draft.fecha_inicio) : undefined,
      fecha_fin: draft.fecha_fin ? new Date(draft.fecha_fin) : undefined,
    }]);
    setDraft({ mensaje: '', status: 'activo', fecha_inicio: '', fecha_fin: '' });
    setOpen(false);
  };

  const persist = async () => {
    try {
      setBusy(true);
      await Pantallas.patchGroup(group._id, { mensajes: rows });
      onSaved?.();
    } catch (e) { console.error(e); alert(e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid gap-4">
      <div className="flex items-center justify-between">
        <div className="text-sm text-white/70">{rows.length} mensajes</div>
        <div className="flex gap-2">
          <button onClick={() => setOpen(true)} className="rounded-xl bg-indigo-600 hover:bg-indigo-500 px-3 py-2 text-sm">Nuevo</button>
          <button disabled={busy} onClick={persist} className="rounded-xl bg-slate-700 hover:bg-slate-600 px-3 py-2 text-sm disabled:opacity-60">Guardar cambios</button>
        </div>
      </div>

      <div className="grid gap-2">
        {rows.map((m) => (
          <div key={m.id} className="grid sm:grid-cols-12 gap-2 items-center rounded-xl bg-white/5 border border-white/10 p-3">
            <input
              value={m.mensaje}
              onChange={e => setRows(rs => rs.map(x => x.id === m.id ? { ...x, mensaje: e.target.value } : x))}
              className="sm:col-span-6 rounded-lg bg-white/0 border border-white/10 px-3 py-2 text-sm"
            />
            <select
              value={m.status}
              onChange={e => setRows(rs => rs.map(x => x.id === m.id ? { ...x, status: e.target.value } : x))}
              className="sm:col-span-2 rounded-lg bg-white/0 border border-white/10 px-3 py-2 text-sm"
            >
              <option value="activo">activo</option>
              <option value="inactivo">inactivo</option>
            </select>
            <input type="datetime-local"
              value={m.fecha_inicio ? new Date(m.fecha_inicio).toISOString().slice(0,16) : ''}
              onChange={e => setRows(rs => rs.map(x => x.id === m.id ? { ...x, fecha_inicio: e.target.value ? new Date(e.target.value) : undefined } : x))}
              className="sm:col-span-2 rounded-lg bg-white/0 border border-white/10 px-3 py-2 text-sm"
            />
            <input type="datetime-local"
              value={m.fecha_fin ? new Date(m.fecha_fin).toISOString().slice(0,16) : ''}
              onChange={e => setRows(rs => rs.map(x => x.id === m.id ? { ...x, fecha_fin: e.target.value ? new Date(e.target.value) : undefined } : x))}
              className="sm:col-span-2 rounded-lg bg-white/0 border border-white/10 px-3 py-2 text-sm"
            />
            <div className="sm:col-span-12 flex gap-2 justify-end">
              <button onClick={() => toggle(m.id)} className="rounded-lg bg-white/10 px-2 py-1 text-xs hover:bg-white/20">{m.status === 'activo' ? 'Desactivar' : 'Activar'}</button>
              <button onClick={() => remove(m.id)} className="rounded-lg bg-red-600/80 hover:bg-red-600 px-2 py-1 text-xs">Eliminar</button>
            </div>
          </div>
        ))}
      </div>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Nuevo mensaje"
        footer={
          <div className="flex justify-end gap-2">
            <button onClick={() => setOpen(false)} className="rounded-xl px-3 py-2 text-sm bg-slate-700 hover:bg-slate-600">Cancelar</button>
            <button onClick={add} className="rounded-xl px-3 py-2 text-sm bg-indigo-600 hover:bg-indigo-500">Agregar</button>
          </div>
        }
      >
        <div className="grid gap-3">
          <LabeledInput label="Mensaje" value={draft.mensaje} onChange={e => setDraft(v => ({ ...v, mensaje: e.target.value }))} />
          <LabeledSelect label="Estado" value={draft.status} onChange={e => setDraft(v => ({ ...v, status: e.target.value }))}>
            <option value="activo">activo</option>
            <option value="inactivo">inactivo</option>
          </LabeledSelect>
          <LabeledInput label="Inicio (datetime-local)" type="datetime-local" value={draft.fecha_inicio} onChange={e => setDraft(v => ({ ...v, fecha_inicio: e.target.value }))} />
          <LabeledInput label="Fin (datetime-local)" type="datetime-local" value={draft.fecha_fin} onChange={e => setDraft(v => ({ ...v, fecha_fin: e.target.value }))} />
        </div>
      </Modal>
    </div>
  );
}
